import { zodResolver } from "@hookform/resolvers/zod"
import { useNavigate } from "@tanstack/react-router"
import { useUpdateWhatsappOpeningMessageMutation } from "modules/campaigns/hooks/sections/openingMessages/useUpdateWhatsappOpeningMessageMutation"
import { useWhatsappOpeningMessageQuery } from "modules/campaigns/hooks/sections/openingMessages/useWhatsappOpeningMessageQuery"
import { useEffect } from "react"
import { useForm } from "react-hook-form"
import { SearchSchema } from "routes/_base/_auth/settings/channels/whatsapp/openings"
import { Route as WhatsappOpeningMessageEditRoute } from "routes/_base/_auth/settings/channels/whatsapp/openings/$id"
import { UpsertWhatsappOpeningMessageSchema } from "schema"
import z from "zod"
import { WhatsappOpeningMessageForm } from "./WhatsappOpeningMessageForm"

export const WhatsappOpeningMessageEdit = () => {
  const navigate = useNavigate()
  const { id } = WhatsappOpeningMessageEditRoute.useParams()
  const { mutateAsync, isPending: mutationIsPending } = useUpdateWhatsappOpeningMessageMutation()
  const { data, isPending } = useWhatsappOpeningMessageQuery({ id })
  const form = useForm<z.infer<typeof UpsertWhatsappOpeningMessageSchema>>({
    resolver: zodResolver(UpsertWhatsappOpeningMessageSchema),
    defaultValues: {
      identifier: "",
      text: "",
      locale: "",
    },
    disabled: mutationIsPending || isPending,
  })

  const onSubmit = async (payload: z.input<typeof UpsertWhatsappOpeningMessageSchema>) => {
    await mutateAsync({ ...payload, id }).then(() => {
      navigate({ to: "/settings/channels/whatsapp/openings", search: SearchSchema.parse({}) })
    })
  }

  useEffect(() => {
    if (data) {
      form.reset({
        identifier: data.identifier,
        locale: data.locale,
        text: data.text,
      })
    }
  }, [data, form])

  return <WhatsappOpeningMessageForm form={form} onSubmit={onSubmit} />
}
